<template>
  <div class="file-input" @click="$refs.input.click()">
    <span class="file-input__label">{{ this.name || $t("CHOOSE_FILE") }}</span>
    <input @change="onChange" ref="input" type="file" class="file-input__control" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
    };
  },
  methods: {
    onChange(e) {
      const file = e.target.files[0];
      if (!file) {
        this.name = '';
        return;
      }

      this.name = file.name;
      const reader = new FileReader();
      reader.onload = (event) => {
        this.$emit('input', event.target.result.replace(/^.*,/, ''));
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>

<style lang="scss" scoped>
.file-input {
  background: var(--tertiary-bg);
  border: 1px solid var(--tertiary-accent);
  border-radius: 2px;
  padding: 6px;
  width: 150px;
  font-size: 14px;
  font-family: "IBM Plex Sans", sans-serif;
  color: var(--text-primary);
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  text-align: left;
  height: 30px;
  line-height: 18px;

  &__label {
    display: inline-block;
    vertical-align: middle;
  }

  &__control {
    display: none;
  }
}
</style>
